import React from "react";
import { Box, Button, Typography } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

const FeaturePlans = () => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        backgroundColor: "#fff",
        alignItems: 'center',
        height: "50vh",
        pb: 2,
      }}
    >
      <Box
        textAlign={"center"}
        sx={{
          py: 4,
          width: { xl: "74%", lg: "79%", md: "90%", sm: "90%" },
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {/* Title */}
        <Typography
          variant="h4"
          fontWeight="bold"
          gutterBottom
          sx={{ fontSize: { xs: "2.3rem", md: "2.8rem" } }}
        >
          Add-on Feature
        </Typography>

        {/* Description */}
        <Typography
          variant="body1"
          sx={{
            color: "#616161",
            px: { xs: 3, md: 3 },
            mb: 4,
            fontSize: { xs: "18px", md: "20px" },
            lineHeight: 1.6,
            maxWidth: { xs: "100%", md: "60vw" },
          }}
        >
          Unlock our advanced drag-and-drop Flow Builder for just ₹1999/month
          and start automating support, lead qualification and product guidance
          instantly.
        </Typography>

        {/* Button */}
        <Button
          variant="contained"
          size="large"
          endIcon={<ArrowForwardIcon />}
          sx={{
            backgroundColor: "#00C851",
            color: "#fff",
            fontWeight: "bold",
            textTransform: "none",
            borderRadius: "8px",
            px: 3,
            py: 1.5,
            "&:hover": {
              backgroundColor: "#00b34d",
            },
          }}
        >
          Explore Plans & Pricing
        </Button>
      </Box>
    </Box>
  );
};

export default FeaturePlans;
